/**
 * Created by Ning Jiang on 2021-05-04.
 */
import {OktoberfestParsedData} from "./OktoberfestParsedData";
import {IOktoberfestInitData, ISymbolValues} from "./IOktoberfestData";
import {OktoberfestDataParser} from "./OktoberfestDataParser";

export class OktoberfestParsedInitData extends OktoberfestParsedData {

    public readonly betLines:number[][];
    public readonly symbolValues:ISymbolValues;
    public readonly isRestoreState:boolean;
    public readonly initReelSetName:string;
    private _beerTokensCollectedInFreespin:number;
   // private _currentMultiplier:number;
    constructor(rawData:IOktoberfestInitData, parser:OktoberfestDataParser) {
        super(rawData, parser);
        console.log("rawData init",rawData);
        this.betLines = rawData.betLines;
        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.initReelSetName = parser.parseInitReelSet(rawData);
        this._beerTokensCollectedInFreespin = parser.parseBeerTokensCollectedInFreespin(rawData);
       // this._currentMultiplier = parser.parseCurrentMultiplier(rawData);
    }
    get beerTokensCollectedInFreespin():number {
        return this._beerTokensCollectedInFreespin;
    }

    // get currentMultiplier():number {
    //     return this._currentMultiplier;
    // }
    protected parseScatterPositions(rawData:IOktoberfestInitData):number[] | undefined {
        return rawData.scatterPositionsEnteringFreespin;
    }
}